import { Checkbox, CheckboxGroup, Heading, Stack, Text, Textarea, useColorModeValue } from '@ecoinvent/ui';

import { USE_CASE_OPTIONS } from '../constants';

interface UseCasesStepProps {
  value: string[];
  otherText: string;
  onChange: (value: string[]) => void;
  onOtherTextChange: (value: string) => void;
}

const UseCasesStep = ({ value, otherText, onChange, onOtherTextChange }: UseCasesStepProps) => {
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const subtitleColor = useColorModeValue('gray.500', 'gray.400');
  const showOtherInput = value.includes('other');

  return (
    <Stack spacing={8} align="center" w="100%">
      <Stack spacing={2} align="center" textAlign="center">
        <Text fontSize="sm" color={subtitleColor}>
          step 2 of 3
        </Text>
        <Heading size="lg" fontWeight="bold">
          How is your organization using ecoinvent data?{' '}
          <Text as="span" fontSize="lg" fontWeight="normal">
            (select all that apply)
          </Text>
        </Heading>
      </Stack>
      <CheckboxGroup value={value} onChange={(val) => onChange(val as string[])}>
        <Stack spacing={3}>
          {USE_CASE_OPTIONS.map((option) => (
            <Checkbox key={option.value} value={option.value} colorScheme="green" size="lg" borderColor={borderColor}>
              {option.label}
            </Checkbox>
          ))}
        </Stack>
      </CheckboxGroup>
      {showOtherInput && (
        <Textarea
          aria-label="Please specify other use case"
          placeholder="Please specify (optional)"
          value={otherText}
          onChange={(e) => onOtherTextChange(e.target.value)}
          maxW="400px"
          w="100%"
          resize="vertical"
        />
      )}
    </Stack>
  );
};

export default UseCasesStep;
